import { Empty, Flex, Spin } from 'antd';

export default function LoadingPlaceholder() {
  return (
    <Flex align="center" justify="center" className="lpe-placeholder">
      <Empty description="Loading" image={<Spin size="large" />} />
    </Flex>
  );
}
